exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border[data-v-805b626c]{border:1px solid rgba(0,0,0,.12)}", ""]);

// exports
